import { Box, Row, Typography } from '@tempmee/react';

interface ITitleProps {
  color: string;
  title: string;
  count?: number;
}

export const Title = ({ color, count = 0, title }: ITitleProps) => (
  <Row align="stretch" gap={2}>
    <Box style={{ width: 4, backgroundColor: color, borderRadius: 4 }} />
    <Typography as="span" bold size="body_large">
      {title} ({count}):
    </Typography>
  </Row>
);
